import { Box, Image, Text, Tooltip, Button, Link } from "@chakra-ui/react";
import { ReactComponent as Calendar } from '../../svg/calendar.svg'
import { ReactComponent as Clock } from '../../svg/clock.svg'
import { ReactComponent as Teacher } from '../../svg/teacher.svg'
import { ReactComponent as Meeting } from '../../svg/meeting.svg'

export default function IndividualLiveSessionCard({ id, title, image, start_time, trainer_name, duration, link }) {
    return (
        <Box
            d='flex'
            flexDir='column'
            width={['95%', '95%', '47%', '30%', '23%']}
            borderRadius='30px'
            bg='#ffffff'
            boxShadow='md'
        >
            <Image
                src={image ? image : './images/unavailable-image.jpg'}
                // fallbackSrc={"https://source.unsplash.com/random/800x600"}
                alt={title}
                borderRadius='30px'
                width='100%'
                height='180px'
                objectFit='cover'
            />
            <Box width='100%' p='1.5rem'>
                <Tooltip
                    label={title}
                    fontSize='20px'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='400'
                    color='#ffffff'
                    bg='#333333'
                    hasArrow
                >
                    <Text
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        fontSize='18px'
                        fontWeight='700'
                        color='#333333'
                        mb='1rem'
                        textTransform='capitalize'
                        whiteSpace='nowrap'
                        overflow='hidden'
                        textOverflow='ellipsis'
                    >
                        {title}
                    </Text>
                </Tooltip>
                <Box
                    d='flex'
                    justifyContent='center'
                    alignItems='flex-start'
                    flexDir='column'
                    style={{ fontFamily: 'Mulish, sans-serif', gap: '1rem' }}
                    fontSize='14px'
                    fontWeight='600'
                    color='#666666'
                >
                    <Box d='flex' justifyContent='center' alignItems='center'>
                        <Teacher width = '18px' height='18px' />
                        <Text ml='2'>{trainer_name}</Text>
                    </Box>
                    <Box d='flex' justifyContent='center' alignItems='center'>
                        <Calendar width = '18px' height='18px'/>
                        <Text ml='2'>{start_time}</Text>
                    </Box>
                    <Box w= '100%' d ='flex' justifyContent = 'space-between' alignItems = 'center'>
                        <Box d='flex' justifyContent='center' alignItems='center'>
                            <Clock width = '18px' height='18px'/>
                            <Text ml='2'>{duration} Minutes</Text>
                        </Box>
                        <Link href={link} style={{ textDecoration: 'none' }} target='_blank'>
                        <Button
                            bg='linear-gradient(90.57deg, #7B90F7 3.35%, #FE5858 94.78%)'
                            borderRadius='7px'
                            py={['10px', '10px', '10px', '8px', '11px']}
                            px={['30px', '30px', '30px', '26px', '32px']}
                            boxShadow='0px 4px 8px rgba(0, 0, 0, 0.1)'
                            d='flex'
                            justifyContent='center'
                            alignItems='center'
                            textTransform='uppercase'
                            style={{ fontFamily: 'Mulish, sans-serif', gap: '0.5rem' }}
                            _hover={{ bg: 'linear-gradient(90.57deg, #6e81dd 3.35%, #FE5858 94.78%)' }}
                            fontSize='12px'
                            fontWeight='800'
                            color='#FFFFFF'
                        >
                            <Meeting width='18px' height = '18px' fill='white' /> Join
                        </Button>
                        </Link>
                    </Box>
                </Box>
            </Box>

        </Box>
    )
}